module.exports = __webpack_public_path__ + "img/legume-black-eyed-peas-350x184.332e994f.jpg";